<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="record-title" fxLayout="row" fxLayoutAlign="start center">
  <div class="spacing-xs record-item" fxLayout="row">
    <div *ngIf="itemIcon" class="spacing-xs record-item-icon" fxLayoutAlign="center center">
      <fa-icon class="icon" [icon]="itemIcon"></fa-icon>
    </div>
    <div class="spacing-xs record-item-title">
      {{ title }}
    </div>
  </div>
  <div fxLayout="row" fxFlex fxLayoutAlign="end center" *ngIf="timestamp && timestamp !== ''">
    <div class="record-item-timestamp">{{ _formattedTimestamp }}</div>
  </div>
</div>
